import React from 'react';
import './ModeSwitch.css'
import { Input } from '../../ui';

export const ModeSwitch = ({ mode, onChange, labels = { amount: "amount", count: "count" } }) => {
  const checked = mode === 'count';

  return (
    <label 
      className="switch" 
      style={{ userSelect: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}
    >
      <span>{labels.count}</span>
      <Input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked ? 'count' : 'amount')}
        style={{ cursor: 'pointer' }}
        />
        <span>{labels.amount}</span>
    </label>
  );
};
